/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from 'react'
import Chart from 'chart.js/auto'
import { ChartWrapper } from './chartUtils.js'

export const Bar = ({ data, title }) => {
  const chartRef = useRef(null)

  useEffect(() => {
    const ctx = chartRef.current.getContext('2d')
    const barChart = new Chart(ctx, {
      type: 'bar',
      data,
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        },
        animation: {
          duration: 2000,
          easing: 'easeOutBounce'
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            enabled: true,
            mode: 'index',
            intersect: false,
            bodySpacing: 5,
            titleSpacing: 6
          }
        }
      }
    })

    return () => barChart.destroy()
  }, [data])

  return (
      <ChartWrapper title={title}>
        <canvas ref={chartRef}></canvas>
      </ChartWrapper>
  )
}
